import { ICONSIZE } from '@techem/ui-components';
import Icon from 'presentation/components/Icon';
import React from 'react';

import chevronIcon from 'presentation/assets/icons/png/3x/chevron-down-red@3x.png';

interface Props {
  className?: string;
  height?: number;
  width?: number;
  fill?: string;
}

const Chevron: React.FC<Props> = ({ className, height = 24, width = 24, fill = 'none' }) => {
  return (
    <div>
      <Icon
        alt="chevron-down-icon"
        centered
        iconSrc={chevronIcon}
        size={ICONSIZE.default}
        className={className}
      />
    </div>
  );
};

export default Chevron;
